import { computed } from "vue";
import { Store } from "vuex";
import { useStore } from "@/store";
import { RootState } from "@/types/root-type";
import { Response } from "@/types/response-type";
import { User, UserComposable, UserLogin } from "@/types/user-type";

export default function useUser(): UserComposable {
  const store: Store<RootState> = useStore();
  const response = computed<Response>(
    () => store.getters["user_module/response"]
  );
  const sign_up_composables = async (form: User): Promise<void> => {
    await store.dispatch("user_module/sign_up_action", form);
  };
  const sign_in_composables = async (form: UserLogin): Promise<void> => {
    await store.dispatch("user_module/sign_in_action", form);
  };
  return { sign_up_composables, sign_in_composables, response };
}
